<template>
    <div class="main">
        <img src="@/assets/bg.jpeg" alt="" class="main-bg">
        <div class="goodsBox">
            <div class="goodsList">
                <ul class="infinite-list" v-infinite-scroll="getList" style="overflow:auto">
                    <li v-for="(item,i) in list" :key="i" class="infinite-list-item" @click="goodsInfo(item.id)">
                        <div class="block">
                            <el-carousel indicator-position="none" height="200px">
                              <el-carousel-item v-for="(image, index) in item.images" :key="index">
                                <el-image :src="image" ></el-image>
                              </el-carousel-item>
                            </el-carousel>
                            <div class="goodsTitle">{{item.title}}</div>
                          </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="loginBox">
            <div class="login">
                <div class="loginTitle">账号登录</div>
                <el-form ref="form" label-width="80px">
                    <el-form-item label="账号">
                        <el-input v-model="username" placeholder="储户手机号"></el-input>
                    </el-form-item>
                    <el-form-item label="密码">
                        <el-input v-model="password" placeholder="储户身份证后6位" show-password></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit" class="submit">登录</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import {
    userLogin,
    goodsList
} from "@/api/api.js";
export default {
    name: "homeIndex",
    data() {
        return {
            show: false,
            username: '',
            password: '',
            page: 1,
            count: 0,
            list: [],
            loading: false,
            finished: false,
        }
    },
    methods: {
        getList() {
            let data = {
                page: this.page
            }
            if (this.page > 1 && this.list.length >= this.count) {
                return false
            }
            // this.loading = false;
            goodsList(data).then(res => {

                let n = []
                let nn = res.data.list
                if (this.page == 1) {
                    n = nn
                } else {
                    n = this.list
                    n = n.concat(nn)
                }
                this.list = n
                this.count = res.data.count
                // 加载状态结束
                this.loading = false;
                this.page++
                // 数据全部加载完成
                if (this.list.length >= this.count) {
                    this.finished = true;
                }
            })
        },
        goodsInfo(id) {
            this.$router.push({ name: 'goodsInfo', query: { id: id } })
        },
        onSubmit() {

            let mobileReg = /^1[3,4,5,7,8,9][0-9]{9}$/;
            if (this.username == "") {
                this.$message.error("手机号不能为空");
                return false
            }
            if (!mobileReg.test(this.username)) {
                this.$message.error("手机号格式有误");
                return false
            }
            if (this.password == "") {
                this.$message.error("密码不能为空");
                return false
            }
            let that = this
            let data = {
                phone: this.username,
                password: this.password
            }
            userLogin(data).then(res => {
                if (res.code == 200) {
                    localStorage.setItem('token', res.data.token);
                    this.$message({
                        type: 'success',
                        message: '登录成功',
                        duration:1000,
                        onClose(){
                            that.$router.push({ name: 'contractList' })
                        }
                    });
                } else {
                    this.$message.error(res.message);
                }
            })

        }
    }
}
</script>
<style lang="scss" scoped>
.main {
    width: 100%;
    height: 100%;
    background-color: #f2f2f2;
    position: relative;
    overflow: hidden;

    .main-bg {
        width: 100%;
        height: 100%;
    }
}

.goodsBox {
    background-color: rgba($color: #f2f2f2, $alpha: 0.8);
    position: absolute;
    left: 80px;
    top: 60px;
    width: 1200px;
    height: 600px;

    .goodsList {
        
        width: 800px;
        margin: 50px;
        height: 500px;

        .infinite-list {
            padding: 10px;
            height: 480px;
            

            .infinite-list-item{
                width: 200px;
                height: 240px;
                margin-right: 60px;
                display: inline-block;
                background: #fff;
                margin-bottom: 20px;
                border-radius: 10px;
                .block{
                    width: 100%;
                    height: 100%;
                }
                .el-image{
                    width: 100%;
                    height: 100%;
                    border-radius: 10px 10px 0 0;
                }
                .goodsTitle{
                    line-height: 40px;
                    height: 40px;
                    text-align: center;
                }
            }
        }
    }
}

.loginBox {
    background-color: rgba($color: #fff, $alpha: 0.8);
    position: absolute;
    right: 80px;
    top: 180px;
    width: 500px;
    z-index: 99;
    .login {
        padding: 50px;
    }

    .loginTitle {
        font-weight: bold;
        color: coral;
        font-size: 20px;
        margin-bottom: 20px;
    }

    .submit {
        width: 100%;
    }
}
</style>